export const LEADERBOARD_LIST = "LEADERBOARD_LIST";
export const SHOW_WINNER = "SHOW_WINNER";
